import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  FormHelperText,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface Props {
  LabelName: string;
  menuItems: any;
  name: any;
  value: any;
  handleChange: any;
  error: any;
  helperText: any;
  setOthers?: any | undefined;
  disabled?: any;
  onBlur?: any;
}

const CommonDropdownLatest: React.FC<Props> = ({
  LabelName,
  menuItems,
  name,
  value,
  handleChange,
  error,
  helperText,
  setOthers,
  disabled,
  onBlur,
}) => {
  //   console.log("value", value);

  return (
    <FormControl fullWidth>
      <Select
        // labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        name={name}
        disabled={disabled}
        label={LabelName}
        placeholder={LabelName}
        error={error}
        displayEmpty
        notched={false}
        onChange={(e) => {
          // console.log(e.target.value.value);
          if (e.target.value.value && setOthers) {
            //  console.log(e.target.value);
            setOthers(e.target.value.value);
          }

          handleChange(e);
        }}
        renderValue={(selected) => {
          if (!value || value === "") {
            return (
              <span style={{ color: "var(--ds-text-secondary)", opacity: 0.6 }}>
                {LabelName}
              </span>
            );
          }
          return selected.value;
        }}
        onBlur={onBlur}
        IconComponent={(props) => (
          <KeyboardArrowDownIcon
            style={{ marginRight: "10px", color: "var(--ds-text-primary)" }}
            {...props}
          />
        )}
        MenuProps={{
          PaperProps: {
            sx: {
              background: "var(--ds-bg)",
              borderRadius: "10px",
              marginTop:"12px",
              border: "1px solid var(--ds-outline)",
              boxShadow: "0 13px 16.1px 0 rgba(0, 0, 0, 0.06)",
              "& li.Mui-selected": {
                backgroundColor: "var(--ds-text-primary) !important",
                color: "var(--ds-bg) !important",
              },
            },
          },
          MenuListProps: {
            sx: {
              "& .MuiPaper-root": {
                borderRadius: "10px",
                background: "var(--ds-bg)",
              },
              "& li": {
                background: "var(--ds-bg)",
                color: "var(--ds-label)",
              },
              "& li.Mui-selected": {
                backgroundColor: "var(--ds-text-primary)",
                color: "var(--ds-bg)",
                "&:hover": {
                  backgroundColor: "var(--ds-text-primary)",
                  color: "var(--ds-bg)",
                },
              },
            },
          },
        }}
        sx={{
          fieldset: {
            borderColor: "#E5E7EB",
          },
          color: "var(--ds-text-primary)",
          fontSize: "14px",
        }}
      >
        {menuItems.map((a: any, index: any) => {
          return (
            <MenuItem
              key={index}
              value={a}
              selected={a === value}
              sx={{ background: "var(--ds-bg)" }}
            >
              {a.value}
            </MenuItem>
          );
        })}
      </Select>
      {/* <div style={{fontSize:'12px', color:'red'}}> {helperText}</div> */}
      <FormHelperText style={{ color: "#d32f2f" }}>{helperText}</FormHelperText>
    </FormControl>
  );
};
export default CommonDropdownLatest;
